import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import classNames from "classnames";
import { Link } from "./link";
import PlayDark from "../icons/play-dark.svg";
import CartIcon from "../icons/carrello.svg";

const ListingItemPdp = ({
  item,
  showVideoModal,
  labelManagerLabels,
  addItemToCart,
  type,
  isFourth,
  isFirst,
  settings,
  showLogoImage,
}) => {
  const isFirstMod = isFirst && !!item?.isFamily;

  return (
    <div className={type === "Tripletta with image position" ? "col-md-12" : "col-md-12"}>
      <div className="items-grid__item-listing">
        <div
          className={classNames("row", {
            "py-0 py-md-5": !isFourth && !isFirstMod,
            "items-grid__first-element-background": isFirstMod,
            "items-grid__fourth-row items-grid__fourth-element pb-2 my-md-4 py-md-4": isFourth,
            "align-items-center": !isFirstMod,
          })}
        >
          {(item.image || item.icon || item.logoImage) && (
            <div
              className={classNames({
                "items-grid__order": !isFirstMod,
                "col-sm-12 d-md-block items-grid__order-first items-grid__first-image": isFirstMod,
                "col-md-4": item.icon && !isFirstMod,
                "col-md-6": !item.icon && !isFirstMod,
                "items-grid__mobile-image": !isFourth && !isFirstMod,
                "mb-5 mb-md-0 items-grid__fourth-image": isFourth,
              })}
            >
              <div className="position-relative">
                {!!item.image?.length && (
                  <Slider
                    {...settings}
                    className={classNames({
                      "slick-slider--pdp": !isFirstMod,
                    })}
                  >
                    {item.image.map((img, i) => (
                      <React.Fragment key={i}>
                        {!img?.node ? (
                          <div className="slick-slider--pdp__image--no-image"> </div>
                        ) : (
                          <>
                            {typeof img.node === "string" ? (
                              <img className="w-100" src={img.node} alt={img.alt} />
                            ) : (
                              <GatsbyImage
                                className="w-100"
                                image={getImage(img.nodeFull || img.node)}
                                alt={img.alt}
                              />
                            )}
                          </>
                        )}
                      </React.Fragment>
                    ))}
                  </Slider>
                )}
                {!item.image?.length && showLogoImage && item?.logoImage?.[0]?.node && (
                  <>
                    {typeof item.logoImage?.[0]?.node === "string" ? (
                      <img
                        className="w-100"
                        src={item.logoImage?.[0]?.node}
                        alt={item.logoImage?.[0]?.content?.altImage?.value || ""}
                      />
                    ) : (
                      <GatsbyImage
                        className="w-100"
                        image={getImage(item.logoImage?.[0]?.node)}
                        alt={item.logoImage?.[0]?.altImage?.value || ""}
                      />
                    )}
                  </>
                )}
                {(!!item.image?.length || item.icon || item?.logoImage?.[0]?.node) && item.youtube && (
                  <button
                    className="btn-play btn-play--center"
                    aria-label="Play"
                    name={item.youtube}
                    onClick={showVideoModal}
                  >
                    <PlayDark />
                  </button>
                )}
                {item.icon?.icon && (
                  <div className="items-grid__icon">
                    <img
                      src={item.icon.icon.node?.publicURL}
                      style={{
                        width: item.icon?.width && `${item.icon?.width}px`,
                        height: item.icon?.heigth && `${item.icon?.heigth}px`,
                      }}
                      alt={`icona box ${item.title}`}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
          <div
            className={classNames({
              "col-sm-12 items-grid__text-wrapper-pdp-first items-grid__order-text-first":
                isFirstMod,
              "col-md-8": item.icon && !isFirstMod,
              "col-md-6": !item.icon && !isFirstMod,
              "text-center text-sm-left d-flex flex-column justify-content-center align-items-start items-grid__order-text":
                !isFirstMod,
              "items-grid__fourth-element": isFourth || isFirstMod,
              "alternate-alignment-left--pdp": isFourth,
            })}
          >
            {item.title && (
              <h3
                className={classNames({
                  "items-grid__item-title--pdp-first": isFirstMod,
                  "items-grid__item-title--pdp": !isFirstMod,
                  "items-grid__item-title--pdp items-grid__item-title--pdp-fourth":
                    !isFirstMod && isFourth,
                })}
              >
                {item.title}
              </h3>
            )}
            {item.realSubTitle && (
              <div
                className="items-grid__item-realsubtitle font-light"
                dangerouslySetInnerHTML={{ __html: item.realSubTitle }}
              ></div>
            )}

            {item.cta &&
              !!item.cta.length &&
              item.cta.map(
                (cta) =>
                  (cta.positionCTA === "top" || cta.positionCTA === "all") &&
                  (item.skuForWashPass && !cta.link ? (
                    <div className="mt-4">
                      <button
                        className={classNames(
                          `btn-link`,
                          cta.btnColor === "White" && "btn-link--white",
                          cta.btnColor === "Blu" && "btn-link--blue",
                          cta.btnColor === "Black" && "btn-link--black"
                        )}
                        name={item.skuForWashPass}
                        onClick={addItemToCart}
                      >
                        {cta.linkLabel ? (
                          cta.linkLabel
                        ) : (
                          <>
                            <CartIcon className="icon-svg-detail" /> {labelManagerLabels.addToCart}
                          </>
                        )}
                      </button>
                    </div>
                  ) : (
                    cta.link && (
                      <div className="mt-4">
                        <Link
                          to={cta.link}
                          className={classNames(
                            `btn-link`,
                            cta.btnColor === "White" && "btn-link--white",
                            cta.btnColor === "Blu" && "btn-link--blue",
                            cta.btnColor === "Black" && "btn-link--black"
                          )}
                        >
                          {cta.linkLabel || labelManagerLabels.discoverMore}
                        </Link>
                      </div>
                    )
                  ))
              )}
            {item.subtitle && (
              <div
                className={classNames({
                  "items-grid__item-subtitle--pdp-first": isFirstMod,
                  "items-grid__item-subtitle--pdp": !isFirstMod,
                })}
                dangerouslySetInnerHTML={{ __html: item.subtitle }}
              ></div>
            )}
            {item.cta && !!item.cta.length
              ? item.cta.map(
                  (cta) =>
                    (cta.positionCTA === "bottom" || cta.positionCTA === "all") &&
                    (item.skuForWashPass && !cta.link ? (
                      <div className="mt-4">
                        <button
                          className={classNames(
                            `btn-link`,
                            cta.btnColor === "White" && "btn-link--white",
                            cta.btnColor === "Blu" && "btn-link--blue",
                            cta.btnColor === "Black" && "btn-link--black"
                          )}
                          name={item.skuForWashPass}
                          onClick={addItemToCart}
                        >
                          {cta.linkLabel ? (
                            cta.linkLabel
                          ) : (
                            <>
                              <CartIcon className="icon-svg-detail" />{" "}
                              {labelManagerLabels.addToCart}
                            </>
                          )}
                        </button>
                      </div>
                    ) : (
                      cta.link && (
                        <div className="mt-4">
                          <Link
                            to={cta.link}
                            className={classNames(
                              `btn-link`,
                              cta.btnColor === "White" && "btn-link--white",
                              cta.btnColor === "Blu" && "btn-link--blue",
                              cta.btnColor === "Black" && "btn-link--black"
                            )}
                          >
                            {cta.linkLabel || labelManagerLabels.discoverMore}
                          </Link>
                        </div>
                      )
                    ))
                )
              : item.cta?.link && (
                  <div className="mt-3 mb-5 d-md-flex justify-content-center">
                    <Link
                      to={item.cta.link}
                      className={classNames("btn-link btn-link--black", {
                        "btn-link--pdp": isFirstMod || isFourth,
                      })}
                    >
                      {item.cta.linkLabel || labelManagerLabels.discoverMore}
                    </Link>
                  </div>
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListingItemPdp;
